import { useState } from "react";
import useForm from "antd/es/form/hooks/useForm";
import request from "project-config/services/request/request";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "@/store/GlobalStore";

export function useChangePassword() {
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [changePasswordForm] = useForm();
  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const { fetchUserData } = useGlobalStore();

  const { t } = useTranslation("error");
  const { t: centerT } = useTranslation("center");
  const submitChangePassword = () => {
    setChangePasswordLoading(true);

    changePasswordForm
      .validateFields()
      .then(async () => {
        const password = changePasswordForm.getFieldValue("password");
        const newPassword = changePasswordForm.getFieldValue("newPassword");
        const { code } = await request.post(
          "/api/rendering/user/updatePassword",
          {
            password,
            newPassword,
          }
        );

        setChangePasswordLoading(false);

        if (code === 200) {
          message.success(
            centerT("user_com_modifyPsw_dialog_success_data_edit")
          );
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          fetchUserData();
          return;
        }

        if (code === 805) {
          message.error(t("user_com_modifyPsw_dialog_err_data_edit"));
          return;
        }

        message.error(t("user_com_modifyPsw_msg_fail_edit"));
      })
      .catch(() => {
        setChangePasswordLoading(false);
      });
  };

  const clearChangePasswordForm = () => {
    changePasswordForm.resetFields();
    setChangePasswordLoading(false);
    setOpenPasswordModal(false);
  };

  return {
    openPasswordModal,
    setOpenPasswordModal,
    changePasswordForm,
    changePasswordLoading,
    submitChangePassword,
    clearChangePasswordForm,
  };
}
